// extracted by mini-css-extract-plugin
export default {"container":"MarkerActive_container__-Q7o1","badge":"MarkerActive_badge__GK2KR"};